import { useLayoutEffect, useRef, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cleanHtml as sanitize } from "@/lib/sanitize";

const MAX = 220;

export function RichText({ html, className = "", testid }) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [long, setLong] = useState(false);
  useLayoutEffect(() => { if (ref.current) setLong(ref.current.scrollHeight > MAX + 40); }, [html]);
  const cut = long && !open;
  return (
    <div>
      <div ref={ref} className={`relative overflow-hidden ${className}`} style={cut ? { maxHeight: MAX } : undefined} data-testid={testid}>
        <div className="asv-rich" dangerouslySetInnerHTML={{ __html: sanitize(html) }} />
        {cut && <div className="asv-fade pointer-events-none absolute inset-x-0 bottom-0 h-16" />}
      </div>
      {long && <button type="button" onClick={() => setOpen(!open)} className="asv-accent mt-2 inline-flex items-center gap-1 text-sm font-semibold" data-testid={`${testid}-toggle`}>
        {open ? <>Show less <ChevronUp className="h-4 w-4" /></> : <>Show more <ChevronDown className="h-4 w-4" /></>}</button>}
    </div>
  );
}
